import { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import EditSensor from '../molecules/sensors/EditSensor';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import DeleteSensorAlert from '../molecules/alerts/DeleteSensorAlert'
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { handleSnackBar } from '../../store/global/actions';
import { setFocusElement, toggleRightDrawer, reRenderInfoBuilder, setReRender } from '../../store/global/actions'
import DeleteIcon from '@material-ui/icons/Delete';
import { getterForSensorName } from '../../config/common';

export default function Sensor({ element }) {

    const dispatch = useDispatch();
    const [action, setAction] = useState(0);
    const [showDeleteAlert, setShowDeleteAlert] = useState(true);

    const detailsBC = [
        { label: getterForSensorName(), url: null },
        { label: element.name, url: null }
    ];


    const onCompletion = (type, action) => {

        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(reRenderInfoBuilder());
                    if (process.env.REACT_APP_AUTO_CLOSE == 'true') {
                        dispatch(toggleRightDrawer());
                    }
                    dispatch(setReRender());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                    dispatch(toggleRightDrawer());
                    break;


                case 'clone':
                    dispatch(handleSnackBar({ open: true, message: `${type} cloned`, severity: "success" }));
                    break;

            }
            dispatch(reRenderInfoBuilder());
            setAction({})
        }
    }

    const handleClickDeleteButton = () => {
        setAction({ action: 'delete_sensor' });
        setShowDeleteAlert(true);
    }

    return (
        <>
            <AppBar position="static">
                <Tabs value={0} aria-label="simple tabs example">
                    <Tab label={getterForSensorName()} />
                </Tabs>
            </AppBar>


            <TabPanel value={0} index={0} >
                {/* <BreadCrumb items={detailsBC}  /> */}
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>

                    <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete Sensor" arrow>
                            <IconButton onClick={e => handleClickDeleteButton()}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                <EditSensor element={element} onCompletion={onCompletion} onClose={() => setAction({})} />
                {action.action == 'delete_sensor' && showDeleteAlert && 
                    <DeleteSensorAlert onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} onClose={() => setAction({})} />
                }
            </TabPanel>

        </>
    )
}